import React from 'react';

import type { ProductLogoSvgProps } from '../types';

export const Remote: React.FC<React.PropsWithChildren<ProductLogoSvgProps>> = ({
  size = '40',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="cogs-v11 cogs-graphic cogs-graphic--remote"
  >
    <title>Remote product logo</title>
    <path
      d="M22.4422 37.3027C20.9664 38.1929 19.1191 38.1929 17.6433 37.3027L6.74619 30.7298C5.35217 29.889 4.5 28.3798 4.5 26.7518V13.2482C4.5 11.6202 5.35217 10.111 6.74619 9.27015L17.6433 2.69728C19.1191 1.80712 20.9664 1.80712 22.4422 2.69728L33.3393 9.27015C34.7334 10.111 35.5855 11.6202 35.5855 13.2482V26.7518C35.5855 28.3798 34.7334 29.889 33.3393 30.7298L22.4422 37.3027Z"
      fill="url(#paint0_linear_3847_41023)"
    />
    <mask
      id="mask0_3847_41023"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="4"
      y="2"
      width="32"
      height="36"
    >
      <path
        d="M22.4422 37.3027C20.9664 38.1929 19.1191 38.1929 17.6433 37.3027L6.74619 30.7298C5.35217 29.889 4.5 28.3798 4.5 26.7518V13.2482C4.5 11.6202 5.35217 10.111 6.74619 9.27015L17.6433 2.69728C19.1191 1.80712 20.9664 1.80712 22.4422 2.69728L33.3393 9.27015C34.7334 10.111 35.5855 11.6202 35.5855 13.2482V26.7518C35.5855 28.3798 34.7334 29.889 33.3393 30.7298L22.4422 37.3027Z"
        fill="url(#paint1_linear_3847_41023)"
      />
    </mask>
    <g mask="url(#mask0_3847_41023)">
      <g opacity="0.65">
        <path
          d="M21.2425 28.6516C20.5046 29.0967 19.5809 29.0967 18.843 28.6516L7.79756 21.9892C6.3001 21.086 6.3001 18.9145 7.79756 18.0112L18.843 11.3489C19.5809 10.9038 20.5046 10.9038 21.2425 11.3489L32.288 18.0112C33.7854 18.9145 33.7854 21.086 32.288 21.9892L21.2425 28.6516Z"
          fill="url(#paint2_linear_3847_41023)"
        />
        <path
          d="M21.2425 28.6516C20.5046 29.0967 19.5809 29.0967 18.843 28.6516L7.79756 21.9892C6.3001 21.086 6.3001 18.9145 7.79756 18.0112L18.843 11.3489C19.5809 10.9038 20.5046 10.9038 21.2425 11.3489L32.288 18.0112C33.7854 18.9145 33.7854 21.086 32.288 21.9892L21.2425 28.6516Z"
          fill="white"
          fillOpacity="0.7"
        />
        <path
          d="M21.2425 28.6516C20.5046 29.0967 19.5809 29.0967 18.843 28.6516L7.79756 21.9892C6.3001 21.086 6.3001 18.9145 7.79756 18.0112L18.843 11.3489C19.5809 10.9038 20.5046 10.9038 21.2425 11.3489L32.288 18.0112C33.7854 18.9145 33.7854 21.086 32.288 21.9892L21.2425 28.6516Z"
          fill="url(#paint3_radial_3847_41023)"
        />
      </g>
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0428 19.9999L4.5 10.6249V29.3749L20.0428 19.9999ZM4.50014 29.3751L20.0429 20.0001V38.7501L4.50014 29.3751Z"
        fill="url(#paint4_linear_3847_41023)"
      />
      <path
        opacity="0.7"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 10.625L20.0428 1.25V20L4.5 10.625ZM35.5856 10.625L20.0428 20V1.25L35.5856 10.625Z"
        fill="url(#paint5_linear_3847_41023)"
      />
      <path
        opacity="0.8"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0428 19.9999L35.5856 29.3749V10.6249L20.0428 19.9999ZM35.5854 29.3752L20.0427 38.7502V20.0002L35.5854 29.3752Z"
        fill="url(#paint6_linear_3847_41023)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3847_41023"
        x1="20.0428"
        y1="-9.75946"
        x2="-10.677"
        y2="19.4602"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF008A" />
        <stop offset="1" stopColor="#921ED9" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3847_41023"
        x1="20.2169"
        y1="-17.1573"
        x2="-16.2863"
        y2="12.5731"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB2474" />
        <stop offset="1" stopColor="#C844DB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3847_41023"
        x1="20.2169"
        y1="1.42159"
        x2="3.5974"
        y2="28.4934"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB2474" />
        <stop offset="1" stopColor="#C844DB" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_3847_41023"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.0216 13.9292) rotate(35.7461) scale(25.7712 28.2902)"
      >
        <stop stopColor="white" stopOpacity="0.87" />
        <stop offset="0.994928" stopColor="white" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_3847_41023"
        x1="14.2142"
        y1="15.4975"
        x2="6.49495"
        y2="26.5434"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3847_41023"
        x1="30.1456"
        y1="13.75"
        x2="18.7953"
        y2="3.13269"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.2" />
        <stop offset="1" stopColor="white" stopOpacity="0.52" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3847_41023"
        x1="20.0427"
        y1="20.0521"
        x2="35.2845"
        y2="23.9199"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="white" stopOpacity="0.18" />
      </linearGradient>
    </defs>
  </svg>
);
